import { Controller } from "@hotwired/stimulus"
import { getColorSync } from "colorthief"


export default class extends Controller {
  connect() {
    this.image = this.element
    this.updateColor = this.updateColor.bind(this)
    this.image.addEventListener("load", this.updateColor)
    // A cached image can finish loading before the controller connects, and never fires "load"
    if (this.image.complete && this.image.naturalWidth > 0) this.updateColor()
  }

  disconnect() {
    this.image.removeEventListener("load", this.updateColor)
  }

  updateColor() {
    try {
      const color = getColorSync(this.image)
      if (color) this.element.parentElement.style.backgroundColor = color.hex()
    } catch (e) {
      console.log(e)
    }
  }
}
